import {BasicCommand} from "./BasicCommand";
import {BasicController} from "../BasicController";
import {BasicSmartfoxConstants} from "../BasicSmartfoxConstants";
import {BasicModel} from "../../model/BasicModel";
import {CommandController} from "./../../../commanding/CommandController";
import {info} from "../../../logging/info";

export class SPECommand extends BasicCommand {
    private static PLAYER_DOES_NOT_EXIST: number = 0;
    private static PLAYER_EXISTS: number = 1;

    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_SOCIAL_PLAYER_EXISTS;
    }

    /**
     *
     * Detailed documentation:
     * https://sites.google.com/a/goodgamestudios.com/tech-wiki/java/gamedocumentation/core/events/socialplayerexistsevent
     *
     * @param error
     *  0     Player does not exist
     *  1     Player exist
     * @param params
     *  0     player name (optional)
     * @return
     */
    public executeCommand(error: number, params: any[]): boolean {
        info("error: " + error + ", params: " + params);

        let playerName: string;

        if (error == SPECommand.PLAYER_DOES_NOT_EXIST) {
            // Player has no account for chosen instance. Display no player name.
            playerName = "";
        }
        else if (error == SPECommand.PLAYER_EXISTS) {
            // Player has account. He is no first visitor anymore.
            this.env.isFirstVisit = false;
            playerName = params[1];
        }

        // Update model
        BasicModel.socialData.setDisplayNameExistingPlayer(playerName);

        CommandController.instance.executeCommand(BasicController.CHOOSE_LOGIN_METHOD);

        return false;
    }
}
